


















import { defineComponent, onMounted } from "@vue/composition-api";
import Router from "@/router";
import Store from "@/store";

import { AuthenticationApi } from "@/api";

const Component = defineComponent({
  name: "Logout",
  setup() {
    const api = new AuthenticationApi();

    async function logOut() {
      try {
        const authorizationTokens =
          Store.getters["Auth/getAuthorizationTokens"];

        if (authorizationTokens !== undefined) {
          await api.authenticationLogout({
            refreshToken: authorizationTokens.refreshToken,
          });
        }
      } finally {
        Store.dispatch("Auth/logOut").then(() => {
          Router.push({
            path: "/auth",
            query: {
              trigger: "logout",
            },
          });
        });
      }
    }

    onMounted(() => {
      logOut();
    });
  },
});

export default Component;
